import type { Category, NavItem } from "@scott/ui-d2c/types";
import type React from "react";
import { BannerNav } from "./banner-nav";
import { CategoryTitle } from "./category-title";
import { useNavigationStore } from "./use-navigation-store";

// Navigation hierarchy constants
const NAV_LEVEL_SECOND = 2;
const NAV_LEVEL_THIRD = 3;

interface SecondPanelProps {
  isActive: boolean;
  data: NavItem | null;
  onPanelChange: (panel: string, data: Category) => void;
}

const SecondPanel: React.FC<SecondPanelProps> = ({
  isActive,
  data,
  onPanelChange,
}) => {
  const { setLevel, clearFromLevel, pushToDataLayer } = useNavigationStore();

  if (!data) {
    return null;
  }
  const hasEntries = (entries: Category[] | undefined) =>
    entries && entries.length > 0;

  const hasBanners =
    data.componentData?.navigationNode.entries &&
    data.componentData.navigationNode.entries.length > 0;
  return (
    <div
      className={`fixed top-0 right-0 bottom-0 left-0 z-20 w-full overflow-hidden border-nav-gray border-r bg-nav-bg-secondary pt-6 pl-20 font-nav-paragraph font-nav-weight text-nav-color transition-transform duration-300 ease-in-out lg:z-40 lg:w-[420px] ${isActive ? "translate-x-0" : "-translate-x-full"}`}
      id="second"
    >
      <div className="h-[88px]" />
      <CategoryTitle
        /* nav items */
        link={data.link}
        linkClicked={() => {
          clearFromLevel(NAV_LEVEL_THIRD);
          pushToDataLayer();
        }}
        linkName={data.linkName}
        title={data.title}
        titleEN={data.titleEN}
      />
      <div className="mr-6 border-nav-gray border-b" />
      <div className="linkscontainer relative max-h-[calc(100vh-224px)] overflow-auto pr-6">
        {hasEntries(data.componentData?.navigationNode.children) && (
          <>
            <ul className="py-3 text-xl">
              {data.componentData?.navigationNode.children.map(
                (category, index) => (
                  <li
                    className={`m-0 cursor-pointer py-2 font-bold text-[16px] hover:text-nav-hover ${category.onSale ? "text-sale hover:text-sale-hover" : ""}`}
                    key={`second-category-${category.titleEN || index}`}
                    onClick={() => {
                      setLevel(NAV_LEVEL_SECOND, category.titleEN, index);
                      onPanelChange("third", category);
                    }}
                  >
                    {category.title || category.titleEN}
                  </li>
                )
              )}
            </ul>
            <div className="border-nav-gray border-b" />
          </>
        )}
        {hasBanners && (
          <BannerNav
            banners={data.componentData?.navigationNode.entries || []}
            currentLevel={NAV_LEVEL_SECOND}
          />
        )}
      </div>
    </div>
  );
};

export { SecondPanel };
